import React, { useRef } from "react";

import useContainerHeight from "../../../../common/useContainerHeight";
import { getTranslation } from "../../../../helpers/getLanguage";
import CustomScrollbar from "../../../common/CustomScrollbar";
import RowAttribute from "./RowAttribute";

const RowsAttributes = ({ rows, attributesPicked, handlePickedAttribute }) => {
  const tableRef = useRef(null);
  const [containerHeight] = useContainerHeight(tableRef, 20);

  const reportsTableStyle = {};
  containerHeight && (reportsTableStyle.height = containerHeight);

  return (
    <div className="attributes-container" ref={tableRef} style={reportsTableStyle}>
      {rows?.length > 0 ? (
        <CustomScrollbar right={-15} dependencies={[rows]}>
          {rows.map((row) => (
            <RowAttribute
              key={row.id}
              row={row}
              attributesPicked={attributesPicked}
              handlePickedAttribute={handlePickedAttribute}
            />
          ))}
        </CustomScrollbar>
      ) : (
        <div className="flex-column report-placeholder">
          <span>{getTranslation("NO_ATTRIBUTES_FOUND")}</span>
          <span>{getTranslation("NO_ATTRIBUTES_MESSAGE")}</span>
        </div>
      )}
    </div>
  );
};

export default RowsAttributes;
